<template>
    <PersonInfo
        :name="`${props.user.firstName} ${props.user.lastName}`"
        :name-highlight="props.nameHighlight"
        :company="props.user.company"
        :job-title="props.user.jobTitle"
        variant="Active"
        :truncate-lines="true"
        class="min-h-13 min-w-0 grow"
    >
        <template #avatar>
            <img
                v-if="props.user.avatarUrl"
                :src="props.user.avatarUrl"
                alt=""
                class="size-12 shrink-0 rounded-full object-cover"
            />
            <InitialsWithBackground
                v-else
                :first-name="props.user.firstName"
                :last-name="props.user.lastName"
                class="size-12 shrink-0 leading-12"
                aria-hidden="true"
            />
        </template>
    </PersonInfo>
</template>

<script setup lang="ts">
import InitialsWithBackground from '@/user/components/InitialsWithBackground.vue';
import PersonInfo from '../PersonInfo/PersonInfo.vue';
import type { UserReferenceUser } from './UserReference.types';

type UserReferencePersonInfoProps = {
    user: UserReferenceUser;
    nameHighlight?: string;
};

const props = defineProps<UserReferencePersonInfoProps>();
</script>
